import Axios from "axios";
import React from "react";
import { connect } from "react-redux";
import { sourceTypes } from "../../constants/cms/sourceType";
import { cmsActions } from "../../store/actions/cms/cms.action";
import { systemLabelActions } from "../../store/actions/system/systemLabel/systemLabel.action";
import ModuleWrapper from "./View/ModuleWrapper";
import { AppBar, IconButton, Toolbar, Tooltip } from "@material-ui/core";
import EditorSidebar from "./Sidebar/EditorSidebar";
import { templateActions } from "../../store/actions/cms/template/template.action";
import { getDefaultPosAndSize, GridLines } from "../helpers/meetingEditor.helper";
import LayoutGrid from "./other/LayoutGrid";
import ViewCompactOutlinedIcon from "@material-ui/icons/ViewCompactOutlined";
import SystemLabel from "../../system/SystemLabel/SystemLabel";
import { Col, Row, Spinner } from "reactstrap";
import GridOnIcon from "@material-ui/icons/GridOn";
import GridOffIcon from "@material-ui/icons/GridOff";
import { HubConnectionBuilder, NullLogger } from "@aspnet/signalr";
import { deepClone } from "../../helpers/objectHelper";
import { defaultModuleSettings } from "../models/defaultModuleSettings";
import { resolutions } from "../models/resolutions";
import { meetingService } from "../../services/meeting/meeting.service";
import AlertDialog from "./other/AlertDialog";
import { clientTypeConstants } from "../../interaction/constants/clientType.constants";
import SaveOutlinedIcon from "@material-ui/icons/SaveOutlined";
import { HeaderPopover } from "./other/HeaderPopover";
import MeetingRoomOutlinedIcon from "@material-ui/icons/MeetingRoomOutlined";
import { securityHelper } from "../../helpers/securityHelper";
import DesktopWindowsOutlinedIcon from "@material-ui/icons/DesktopWindowsOutlined";
import EventSelector from "./other/EventSelector";
import { FontInjector } from "../../digitalArena/components/MeetingLayout";
import "../style/EditorStyle.css";
import { ConnectionStatus } from "../../digitalArena/components/fallbacks/ConnectionStatus";
import { FontBasline } from "../../digitalArena/components/shared/FontBaseline";

class MeetingEditorLayout extends React.Component {
  state = {
    modules: [],
    layouts: [],
    permissions: [],
    eventId: null,
    selectedLayout: null,
    selectedTemplate: null,
    changedLayoutModules: [],
    connected: false,
    changedModules: [],
    changedLayouts: [],
    changedTemplates: [],
    activeTemplateId: null,
    eventCode: "",
    versions: [],
    isSavable: false,
    mainEventId: null,
    showLayoutGrid: true,
    versionIndex: 0,
    lang: "swe",
    events: [],
    preview: false,
    previewOpt: null,
    previewLoading: false,
    previewProps: null,
    layoutBackup: [],
    gridLines: false,
    saving: false,
    activeLayout: null,
    templateChanged: false,
    saved: false,
    dialog: null,
    selectedModule: null,
    saveQueued: false,
    connecting: false,
    countdown: 0,
    tickCode:null
  };

  componentDidMount() {
    const { dispatch, user, match } = this.props;
    if (user) {
      this.init();
      const userLang = user.userLang === undefined ? user.token.userLang : user.userLang;
      if (user && userLang) {
        dispatch(systemLabelActions.getGroup(user.userLang, "Interaction.Editor"));
      }
    }
  }
  init = () => {
    const { dispatch, user, match } = this.props;
    const eventId = match.params.id;

    if (isNaN(eventId)) {
      this.setState({ eventCode: eventId });
      this.getEventId(eventId);
    } else {
      this.setState({ eventId: eventId });
      this.getEventCode(eventId);
      /*         dispatch(templateActions.getAll(eventId, true)); */
      this.setState({ eventId: parseInt(eventId) });
      this.getRequirements(eventId);
    }
  };
  componentDidUpdate(prevProps, prevState) {
    const { template, dispatch, location } = this.props;
    const { activeTemplateId, connected, eventId, activeLayout } = this.state;
    const { match } = this.props;
    const { connecting, dismissConnectionLoss, forceDisc } = this.state;
    //If the event is changed re-init the editors configs
    if (location !== prevProps.location) {
      this.init();
    }

    if (
      template &&
      prevProps.template &&
      template.templateId == activeTemplateId &&
      template.updated != prevProps.template.updated &&
      connected &&
      this.hubConnection &&
      this.hubConnection.connectionState == 1
    ) {
      /*    this.hubConnection.invoke("updateTemplate", eventId, activeTemplateId); */
    }

    //If you edit a inherited template that is set on the selectedlayout
    // change the templateId on the layout and reload the templates fetch
    const { selectedLayout, layouts, mainEventId } = this.state;
    if (template && prevProps.template && template.templateId != prevProps.template.templateId && selectedLayout) {
      const layout = layouts.find((l) => l.meetingLayoutId == selectedLayout.value);
      if (layout && layout.templateId != template.templateId && layout.templateId == prevProps.template.templateId && prevProps.template.eventId != mainEventId) {
        dispatch(templateActions.getAll(mainEventId, true));
        this.layoutTemplateOnChange(template.templateId);
      }
    }

    if (connected == false && prevState.connected == true && connecting == false) {
      this.tryReconnect();
      this.counter = setInterval(() => this.setState({ countdown: this.state.countdown + 1 }), 1000);
    } else if (this.state.countdown >= 60 && !connected && prevState.connected == false) {
      this.setState({ countdown: 0, connecting: false });
      this.tryReconnect();
    } else if (connected == true && prevState.connected == false && !this.state.connecting && this.hubConnection && this.hubConnection.connectionState == 1) {
      if (this.counter) clearInterval(this.counter);
      if (this.state.saveQueued) {
      }
      this.setState({ countdown: 0 });
    }
  }
  getRequirements = (eventId) => {
    const { dispatch } = this.props;

    this.setState({ eventId: parseInt(eventId) });
    meetingService.getModules(eventId).then((modules) => {
      this.setState({ modules });
    });
    meetingService.getPermissions(eventId).then((permissions) => {
      this.setState({ permissions });
    });
    meetingService.getLayouts(eventId).then((layouts) => {
      const eventLayouts = Array.from(layouts.filter((l) => l.eventId == eventId));
      this.setState({
        showLayoutGrid: eventLayouts.length == 0,
        layoutsLoaded: true,
        layouts,
        selectedLayout:
          eventLayouts.length > 0
            ? {
                value: eventLayouts[0].meetingLayoutId,
                label: eventLayouts[0].name,
              }
            : null,
      });
      if (layouts.length > 0 && layouts.find((l) => l.eventId == eventId)?.templateId) {
        dispatch(templateActions.get(layouts.find((l) => l.eventId == eventId)?.templateId));
      }
    });
  };
  getAllEvents = (eventId) => {
    Axios.get(`./api/event/getall/${eventId}`)
      .then(({ data }) => {
        this.setState({
          events: data,
        });
      })
      .catch((err) => {
        console.error(err);
      });
  };
  getEventId = (eventCode) => {
    const { dispatch } = this.props;
    Axios.get(`./api/event/getId/${eventCode}`)
      .then(({ data }) => {
        const { id, parentEventId, name } = data;
        const eventId = id;
        this.setState({
          eventId: parseInt(eventId),
          eventName: name,
          parentEventId: parentEventId,
          mainEventId: parentEventId || eventId,
        });
        document.title = "Editor - " + name;
        dispatch(templateActions.getAll(parentEventId || eventId, true));
        dispatch(cmsActions.getClientFonts(parentEventId || eventId));
        dispatch(cmsActions.setEnviroment(sourceTypes.MEETING, true, parentEventId || eventId));
        this.getAllEvents(eventId);
        this.getRequirements(eventId);
        this.connectToHub(parseInt(eventId));
      })
      .catch((err) => {
        console.error(err);
      });
  };
  getEventCode = (eventId) => {
    const { dispatch } = this.props;
    Axios.get(`./api/event/getCode/${eventId}`)
      .then((res) => {
        this.connectToHub(eventId);
        this.setState({
          eventCode: res.data.code,
          eventName: res.data.name,
          parentEventId: res.data.parentEventId,
          mainEventId: res.data.parentEventId || res.data.id,
        });

        dispatch(cmsActions.setEnviroment(sourceTypes.MEETING, true, res.data.parentEventId || eventId));
        dispatch(cmsActions.getClientFonts(res.data.parentEventId || eventId));
        this.getAllEvents(eventId);
        dispatch(templateActions.getAll(res.data.parentEventId || eventId, true));
        document.title = "Editor - " + res.data.name;
      })
      .catch((err) => {
        console.error(err);
      });
  };
  connectToHub = () => {
    const { dispatch } = this.props;

    if (this.state.connecting) return;

    if (!this.hubConnection) {
      this.hubConnection = new HubConnectionBuilder().withUrl("./ihub").build();
    }
    if (this.hubConnection.connectionState == 1) return;

    this.setState({ connecting: true });

    this.hubConnection.start().then(() => {
      this.hubConnection.on("onGetActiveMeetingLayout", (layout) => {
        if (!layout) return;
        //if (layout && layout.templateId) dispatch(templateActions.get(layout.templateId));
        this.setState({
          activeLayout: layout,
        });
      });
      this.hubConnection.on("onHandshake", this.onHandshake);

      this.hubConnection.invoke("getActiveMeetingLayout", this.state.eventId);

      const handshakeObj = {
        eventId: this.state.eventId,
        clientType: clientTypeConstants.INTERACTION_EDITOR,
        clientKey: null,
        userGuid: null,
        userInfo: null,
      };

      this.hubConnection.onclose(() => {
        this.setState({ connected: false });
      });

      this.hubConnection.invoke("handshake", handshakeObj);
    });
  };
  tryReconnect = () => {
    if (!this.state.connecting && !this.state.connected) {
      this.setState({ loading: true }, this.connectToHub);
    }
  };

  onHandshake = (response) => {
    const { success, lang, tickCode } = response;
    if (success) {
      this.setState({
        connected: true,
        connecting: false,
        lang,
        tickCode
      });
      /* this.hubConnection.invoke("getActiveTemplateId", this.state.eventId); */
    }
  };
  beforeSave = () => {
    const { eventId, activeLayout, changedLayoutModules, saving, activeTemplateId, mainEventId, connected, connecting } = this.state;

    const { templateIsSavable, template } = this.props;

    if (saving) return;

    if (connecting && !connected) {
      const dialogContext = {
        title: "ConnectionLossWarning",
        text: "ConnectionLossWarningInfo",
        onCancel: () => this.setState({ dialog: null }),
        onAction: () => this.onSave(true),
      };
      this.setState({ dialog: dialogContext });
      return;
    }

    let text = "SavingChangesToActiveLayout";
    let affectActiveLayout = false;
    let affectActiveTemplate = false;
    let affectiveTemplateInheritage = false;
    if (activeLayout) {
      const hasChanged = changedLayoutModules.find((cl) => cl.meetingLayoutId == activeLayout.meetingLayoutId);
      if (hasChanged) affectActiveLayout = true;
    }

    if (templateIsSavable && ((template && template.templateId == activeTemplateId) || (activeLayout && activeLayout.templateId == template.templateId))) {
      affectActiveTemplate = true;
    }

    if (templateIsSavable && template && template.eventId != mainEventId) {
      affectiveTemplateInheritage = true;
    }

    if (affectActiveLayout || affectActiveTemplate || templateIsSavable) {
      if (affectActiveLayout && affectActiveTemplate) {
        text = "SavingChangesToActiveLayoutAndTemplate";
      } else if (affectActiveLayout) {
        text = "SavingChangesToActiveLayout";
      } else if (affectActiveTemplate) {
        text = "SavingChangesToActiveTemplate";
      }

      if (affectiveTemplateInheritage && !affectActiveLayout) {
        text = "TemplateInheritageInfo";
      } else if (affectiveTemplateInheritage) {
        text += "TemplateInheritageInfo";
      }

      const dialogContext = {
        title: "SaveWarning",
        text,
        onCancel: () => this.setState({ dialog: null }),
        onAction: () => this.onSave(true),
      };

      this.setState({ dialog: dialogContext });

      return;
    }

    this.onSave();
  };
  onSave = (publish = false) => {
    const { activeTemplateId, connected, eventId, activeLayout, modules } = this.state;
    const { template, dispatch, templateIsSavable } = this.props;
    this.setState({ saving: true, dialog: null });
    const changedLayoutModules = Array.from(
      this.state.changedLayoutModules.filter((cl) => {
        if (cl.added && cl.deleted) {
        } else return cl;
      })
    );
    let changedModules = Array.from(this.state.changedModules);
    changedModules = changedModules
      .filter((c) => {
        if (c.added && c.deleted) {
        } else return c;
      })
      .map((c) => {
        const cl = deepClone(c);
        cl.settings = JSON.stringify(cl.settings);
        return cl;
      });

    const changedLayouts = Array.from(
      this.state.changedLayouts.filter((cl) => {
        if (cl.added && cl.deleted) {
        } else return cl;
      })
    );

    changedLayoutModules.map((cl) => {
      if (cl.added && cl.deleted) {
      } else if (cl.added) {
        cl.status = "added";
      } else if (cl.deleted) {
        cl.status = "deleted";
      } else {
        cl.status = "updated";
      }
      delete cl.edited;
      delete cl.deleted;
      delete cl.added;
      /*    cl.meetingModule = null;
      cl.setting = null; */
    });
    changedModules.map((cl) => {
      if (cl.added && cl.deleted) {
      } else if (cl.added) {
        cl.status = "added";
      } else if (cl.deleted) {
        cl.status = "deleted";
      } else {
        cl.status = "updated";
      }

      delete cl.edited;
      delete cl.deleted;
      delete cl.added;
    });
    changedLayouts.map((cl) => {
      if (cl.added && cl.deleted) {
      } else if (cl.added) {
        cl.status = "added";
      } else if (cl.deleted) {
        cl.status = "deleted";
      } else {
        cl.status = "updated";
      }
      delete cl.edited;
      delete cl.deleted;
      delete cl.added;
    });
    let meetingChanges = changedLayoutModules.length > 0 || changedLayouts.length > 0 || changedModules.length > 0;
    if (meetingChanges) {
      Axios.put(`./api/meeting/save/`, {
        changedModules,
        changedLayoutModules,
        changedLayouts,
        eventId: parseInt(this.state.eventId),
      })
        .then(({ data }) => {
          const { layouts } = data;
          //If selected layout was created (select the same one with a new id)
          const layoutsOnEvent = layouts.filter((l) => l.eventId == eventId);
          let selectedLayout = this.state.selectedLayout;
          if ((selectedLayout && selectedLayout.value < 0) || selectedLayout.value == -0) {
            let comparisionValue = selectedLayout.value == -0 ? 0 : selectedLayout.value;

            let newSelectedLayout = layoutsOnEvent.find((l) => l.oldId == comparisionValue);
            if (layouts.length == layoutsOnEvent.filter((l) => l.oldId == 0).length && comparisionValue == 0) {
              comparisionValue = layoutsOnEvent[layouts.length - 1].meetingLayoutId;
              newSelectedLayout = layoutsOnEvent.find((l) => l.meetingLayoutId == comparisionValue);
            }

            if (newSelectedLayout) {
              selectedLayout = {
                value: newSelectedLayout.meetingLayoutId,
                label: newSelectedLayout.name,
              };
            } else {
              selectedLayout = null;
            }
          }

          if (selectedLayout && !layouts.find((l) => l.meetingLayoutId == selectedLayout.value)) {
            selectedLayout = null;
          }

          if (this.hubConnection && this.hubConnection.connectionState == 1 && this.state.connected && changedModules.length > 0) {
            this.hubConnection.invoke("meetingModulesUpdate", eventId, data.modules);
          }
          if (this.hubConnection && this.hubConnection.connectionState == 1 && this.state.connected && activeLayout && publish) {
            this.hubConnection.invoke("activeLayoutUpdate", eventId, activeLayout.meetingLayoutId, activeLayout.mobile ? 9 : 0);
          }

          if (this.hubConnection && this.hubConnection.connectionState == 1 && this.state.connected && activeLayout /* && publish */) {
            this.hubConnection.invoke("activeLayoutUpdate", eventId, selectedLayout?.value, layouts.find((l) => l.meetingLayoutId == selectedLayout.value)?.mobile ? 9 : 0);
          }

          const modules = Array.from(
            data.modules.map((r) => {
              let m = r;
              if (r.settings.length > 0 && r.settings != " ") {
                m.settings = JSON.parse(m.settings);
              }
              return m;
            })
          );

          this.setState({
            layouts,
            modules,
            isSavable: false,
            selectedLayout,
            saving: false,
            changedLayoutModules: [],
            changedModules: [],
            changedLayouts: [],
            changedTemplates: [],
            selectedModule: null,
          });
        })
        .catch(() => {
          this.setState({ saving: false, isSavable: false, dialog: null });
        });
    }

    if (templateIsSavable) {
      const templateCallback = () => {
        if (this.state.templateChanged || (templateIsSavable && this.state.activeLayout && this.state.activeLayout.templateId == template.templateId)) {
          /*     this.hubConnection.invoke("updateTemplate", this.state.eventId, template.templateId); */
        }
      };
      const newTemplate = deepClone(template);
      newTemplate.eventId = parseInt(this.state.mainEventId);
      dispatch(templateActions.update(newTemplate, templateCallback));
    }

    if (!meetingChanges) {
      this.setState({ saving: false });
    }
  };

  templateUpdateCallback = () => {};

  setScale = () => {
    const adjustedResolution = (window.innerHeight - 55) * 1.77 * (window.innerHeight - 55);

    const actualResolution = window.innerWidth * window.innerHeight;

    let diff = adjustedResolution / actualResolution;
    this.setState({
      resolution: {
        value: window.innerWidth * window.innerHeight,
        label: `${window.innerWidth}x${window.innerHeight}`,
      },
      scale: diff,
    });
  };
  addOrUpdate = (item, path, identifier, callback = null) => {
    const list = Array.from(this.state[path]);
    if (Array.isArray(item)) {
      item.map((i) => {
        if (
          list.some((er) => {
            return er[identifier] === i[identifier];
          })
        ) {
          list.map((er) => {
            if (er[identifier] === i[identifier]) {
              if (er.deleted === true && i.deleted === true) i.deleted = false;
              er = Object.assign(er, i);
            }
          });
        } else {
          list.push(i);
        }
      });
    } else {
      if (
        list.some((er) => {
          return er[identifier] === item[identifier];
        })
      ) {
        list.map((er) => {
          if (er[identifier] === item[identifier]) {
            if (er.deleted === true && item.deleted === true) item.deleted = false;
            er = Object.assign(er, item);
          }
        });
      } else {
        list.push(item);
      }
    }

    this.setState({ [path]: list, isSavable: true }, () => {
      if (callback && typeof callback == "function") {
        setTimeout(() => callback(), 1000);
      }
    });
  };
  updateLayout = (layout, callback = null) => {
    const layouts = Array.from(this.state.layouts);
    const prevLayout = layouts.find((l) => l.meetingLayoutId == layout.meetingLayoutId);
    let index = 0;
    if (!prevLayout) return;
    index = layouts.indexOf(prevLayout);
    if (index == -1) return;
    layouts[index] = layout;
    this.addOrUpdate(layouts[index], "changedLayouts", "meetingLayoutId", callback);
    this.setState({
      layouts,
      isSavable: true,
      templateChanged: prevLayout.templateId != layout.templateId,
    });
  };
  undoChange = () => {
    const backup = Array.from(this.state.layouts);
    const { versionIndex, versions } = this.state;
    if (versionIndex <= versions.length - 1) return;
    const requestedVersion = this.state.versions[versionIndex - 1];
    this.setState({ layouts: requestedVersion });
  };
  updateModule = (module) => {
    const { selectedModule } = this.state;
    if (!selectedModule) return;
    const modules = Array.from(this.state.modules);
    let moduleIndex = modules.indexOf(modules.find((m) => m.meetingModuleId == module.meetingModuleId));
    const { settings, displayName } = module;
    if (moduleIndex > -1) {
      modules[moduleIndex] = { ...modules[moduleIndex], settings, displayName };
    }
    this.addOrUpdate({ ...modules[moduleIndex], settings, displayName, edited: true }, "changedModules", "meetingModuleId");
    this.setState({ modules, isSavable: true, selectedModule: module });
  };
  updateLayoutModule = (module) => {
    const id = module.meetingModuleLayoutId;
    const { selectedLayout, layouts, changedLayoutModules, changedLayouts } = this.state;
    if (!selectedLayout) return;
    let selectedModule = deepClone(this.state.selectedModule);
    const versions = Array.from(this.state.versions);
    versions.push(layouts);

    let index = layouts.indexOf(layouts.find((l) => l.meetingLayoutId == selectedLayout.value));
    if (index > -1) {
      this.addOrUpdate({ ...layouts[index], edited: true }, "changedLayouts", "meetingLayoutId");
      this.addOrUpdate({ ...module, edited: true }, "changedLayoutModules", "meetingModuleLayoutId");
      let moduleIndex = layouts[index].meetingModules.indexOf(layouts[index].meetingModules.find((m) => m.meetingModuleLayoutId == module.meetingModuleLayoutId));
      if (moduleIndex > -1) {
        layouts[index].meetingModules[moduleIndex] = module;
        selectedModule = {
          ...selectedModule,
          ...layouts[index].meetingModules[moduleIndex],
        };
      }
    }
    this.setState({
      layouts,
      selectedModule,
      versions,
      isSavable: true,
      versionIndex: versions.length - 1,
    });
  };
  addModule = (type, moduleId = null, position = null) => {
    const { eventId, selectedLayout, layouts, modules, changedModules, changedLayoutModules } = this.state;
    let layoutId = selectedLayout ? selectedLayout.value : -1000;
    let cLayout = layouts.find((l) => l.meetingLayoutId == layoutId);
    let added = changedModules.filter((c) => c.added == true).length;
    let addedLm = changedLayoutModules.filter((c) => c.added == true).length;
    let module = modules.find((m) => m.meetingModuleId == moduleId);
    let mId = moduleId > 0 ? moduleId : added * -1;
    let mLId = addedLm * -1;
    let meetingModule = {
      moduleType: type,
      eventId,
      meetingModuleId: mId,
      displayName: "",
      inserted: new Date().toISOString(),
      settings: module ? module.settings : defaultModuleSettings(type),
    };
    let layoutModule = {
      ...getDefaultPosAndSize(type, position),
      sortOrder: cLayout ? (cLayout.meetingModules.length > 0 ? cLayout.meetingModules.length - 1 : 0) : 0,
      meetingLayoutId: layoutId,
      meetingModuleId: mId,
      meetingModuleLayoutId: mLId,
    };

    if (!modules.find((m) => m.meetingModuleId == meetingModule.meetingModuleId)) {
      modules.push(meetingModule);
      this.addOrUpdate({ ...meetingModule, added: true }, "changedModules", "meetingModuleId");
    }
    if (layoutId != -1000) {
      let index = layouts.indexOf(layouts.find((l) => l.meetingLayoutId == layoutModule.meetingLayoutId));
      if (index > -1) {
        this.addOrUpdate({ ...layouts[index], edited: true }, "changedLayouts", "meetingLayoutId");
        this.addOrUpdate({ ...layoutModule, added: true }, "changedLayoutModules", "meetingModuleLayoutId");
        layouts[index].meetingModules.push(layoutModule);
      }
    }
    this.setState({
      layouts,
      isSavable: true,
      selectedModule: {
        ...layoutModule,
        settings: meetingModule.settings,
        moduleType: type,
      },
    });
  };
  onPreview = (label, value) => {
    const mock = this.state.selectedLayout;
    if (typeof label != "string" && value == null) {
      this.setState(
        {
          previewProps: null,
          preview: false,
          previewOpt: null,
          selectLayout: null,
          previewLoading: true,
        },
        () => {
          setTimeout(
            () =>
              this.setState({
                selectLayout: mock,
              }),
            500
          );
        }
      );
      setTimeout(
        () =>
          this.setState({
            previewLoading: false,
          }),
        1000
      );
      return;
    }
    const w = label.split("x")[0];
    const h = label.split("x")[1];
    const props = this.findPerfectRatio(w, h);

    this.setState(
      {
        selectedModule: null,
        preview: true,
        previewLoading: true,
        previewOpt: { label, value },
        previewProps: props,
        selectLayout: null,
      },
      () => {
        setTimeout(
          () =>
            this.setState({
              selectLayout: mock,
            }),
          500
        );
      }
    );
    setTimeout(
      () =>
        this.setState({
          previewLoading: false,
        }),
      1000
    );
  };
  copyLayout = (c, copies = 1, name = null) => {
    const { changedLayouts, changedLayoutModules, changedModules, modules, eventId } = this.state;

    const layouts = Array.from(this.state.layouts);
    const newModules = Array.from(this.state.modules);
    let newLayoutId = changedLayouts.filter((c) => c.added == true).length;
    let newLayoutModuleId = changedLayoutModules.filter((c) => c.added == true).length;

    let newModuleId = changedModules.filter((c) => c.added == true).length;
    let newLayoutModules = [];
    let newLayouts = [];

    for (let index = 0; index < copies; index++) {
      let copy = {
        ...deepClone(c),
        added: true,
        eventId: this.state.eventId,
        updated: null,
        inserted: new Date().toISOString(),
        oldId: 0,
        updateBy: null,
      };

      copy.meetingLayoutId = newLayoutId * -1;
      copy.name = name || c.name + ` (kopia ${newLayoutId})`;
      copy.meetingModules = [];

      for (let index2 = 0; index2 < c.meetingModules.length; index2++) {
        let meetingModule = deepClone(c.meetingModules[index2]);

        const moduleDoNotExist = !modules.find((m) => m.meetingModuleId == meetingModule.meetingModuleId);

        meetingModule = {
          ...meetingModule,
          meetingModuleId: moduleDoNotExist ? newModuleId * -1 : meetingModule.meetingModuleId,
          meetingLayoutId: newLayoutId * -1,
          meetingModuleLayoutId: newLayoutModuleId * -1,
          inserted: new Date().toISOString(),
          updated: null,
          added: true,
        };
        copy.meetingModules.push(meetingModule);
        newLayoutModules.push(meetingModule);
        newLayoutModuleId += 1;

        //If the module do not exist on the event (press. copying an inherited layout)
        if (moduleDoNotExist) {
          const newModule = {
            ...meetingModule.meetingModule,
            eventId: this.state.eventId,
            meetingModuleId: newModuleId * -1,
            inserted: new Date().toISOString(),
            settings: JSON.parse(meetingModule.meetingModule.settings),
            added: true,
          };
          newModules.push(newModule);

          //modify the layout module accordingly to the spec. from newly created module copy
          meetingModule.meetingModule.eventId = eventId;
          meetingModule.meetingModule.meetingModuleId = newModuleId;

          newModuleId += 1;
        }
      }

      layouts.push(copy);
      newLayouts.push(copy);
      newLayoutId += 1;
    }

    this.addOrUpdate(newModules, "changedModules", "meetingModuleId");
    this.addOrUpdate(newLayoutModules, "changedLayoutModules", "meetingModuleLayoutId");
    this.addOrUpdate(newLayouts, "changedLayouts", "meetingLayoutId");

    this.setState({ layouts, isSavable: true, modules: newModules });
  };
  createLayout = (name, copy = null, copies = 1, mobile = false) => {
    const { template, templates } = this.props;
    const { changedLayouts, changedLayoutModules } = this.state;
    const newId = changedLayouts.filter((c) => c.added == true).length;
    const layouts = Array.from(this.state.layouts);
    let addedLm = changedLayoutModules.filter((c) => c.added == true).length;

    let newLayout = {
      name,
      updated: null,
      inserted: new Date().toISOString(),
      oldId: 0,
      meetingLayoutId: newId * -1,
      templateId: template ? template.templateId : templates[0].templateId,
      meetingModules: [],
      eventId: this.state.eventId,
      added: true,
      mobile,
      updateBy: null,
    };

    if (copy) {
      this.copyLayout(copy, copies, name);
      return;
    }
    layouts.push(newLayout);
    this.setState({ layouts, isSavable: true });
    this.addOrUpdate(newLayout, "changedLayouts", "meetingLayoutId");
  };
  deleteLayoutModule = (layoutModule) => {
    const { selectedLayout, layouts, changedLayoutModules, changedLayouts } = this.state;
    if (!selectedLayout) return;

    const versions = Array.from(this.state.versions);
    versions.push(layouts);

    this.addOrUpdate({ ...layoutModule, deleted: true }, "changedLayoutModules", "meetingModuleLayoutId");
    this.setState({
      versions,
      isSavable: true,
      versionIndex: versions.length - 1,
    });
  };
  deleteModule = (module) => {
    const modules = Array.from(this.state.modules);
    const index = modules.indexOf(modules.find((m) => m.meetingModuleId == module.meetingModuleId));
    if (index > -1) modules[index].deleted = modules[index].deleted ? false : true;

    this.addOrUpdate({ ...module, deleted: true }, "changedModules", "meetingModuleId");
    this.setState({ modules });
  };
  deleteLayout = (layout) => this.addOrUpdate({ ...layout, deleted: true }, "changedLayouts", "meetingLayoutId");
  getLayoutModules = () => {
    const { layouts, selectedLayout, modules } = this.state;
    if (selectedLayout && modules && modules.length > 0) {
      const id = selectedLayout.value;
      const layoutMoudles = layouts.find((l) => l.meetingLayoutId == id);
      if (layoutMoudles) {
        return layoutMoudles.meetingModules.map((mm) => {
          let moduleParent = modules.find((m) => m.meetingModuleId == mm.meetingModuleId);
          if (moduleParent) {
            const { moduleType, settings, displayName } = moduleParent;

            return { ...mm, moduleType, settings, displayName };
          }
        });
      }
    }
    return [];
  };
  groupTemplate = () => {
    const { template } = this.props;
    if (template) {
      return template.content;
    }
    return null;
  };
  findPerfectRatio = (w, h) => {
    const affordableHeight = window.innerHeight - 55;
    const affordableWidth = window.innerWidth - 320;
    let comparisonWidth = w;
    let comparisonHeight = h;
    let ratioFound = false;
    while (!ratioFound) {
      if (affordableHeight < comparisonHeight || affordableWidth < comparisonWidth) {
        comparisonHeight -= 1;
        comparisonWidth -= 1;
      }

      if (affordableHeight >= comparisonHeight && affordableWidth >= comparisonWidth) {
        ratioFound = true;
      }
    }
    const newRatio = (comparisonWidth * comparisonHeight) / (affordableWidth * affordableHeight);
    return {
      transform: newRatio,
      scale: (affordableWidth * affordableHeight) / (parseInt(w) * parseInt(h)),
      width: w + "px",
      height: h + "px",
    };
  };
  postionAndSizeOnChange = (path, v, meetingModuleLayoutId) => {
    const { layouts, selectedLayout } = this.state;

    let selectedModule = deepClone(this.state.selectedModule);
    let value = v;

    let index = layouts.indexOf(layouts.find((l) => l.meetingLayoutId == selectedLayout.value));
    if (index > -1) {
      let moduleIndex = layouts[index].meetingModules.indexOf(layouts[index].meetingModules.find((m) => m.meetingModuleLayoutId == meetingModuleLayoutId));
      if (moduleIndex > -1) {
        layouts[index].meetingModules[moduleIndex][path] = value;
        this.updateLayoutModule(layouts[index].meetingModules[moduleIndex]);
        selectedModule = { ...selectedModule, [path]: value };
        this.setState({ selectedModule });
      }
    }
  };
  onSelectModule = (mm) => {
    const { layouts, selectedLayout, changedLayoutModules } = this.state;
    let layoutModule = {};
    let index = layouts.indexOf(layouts.find((l) => l.meetingLayoutId == selectedLayout.value));
    if (index > -1) {
      let moduleIndex = layouts[index].meetingModules.indexOf(layouts[index].meetingModules.find((m) => m.meetingModuleId == mm.meetingModuleId));
      if (moduleIndex > -1) {
        layoutModule = layouts[index].meetingModules[moduleIndex];
      }
    }
    this.setState({
      selectedModule: {
        ...mm,
        ...layoutModule,
        deleted: layoutModule.meetingModuleLayoutId ? changedLayoutModules.find((cl) => cl.meetingModuleLayoutId == layoutModule.meetingModuleLayoutId && cl.deleted == true) : false,
        moduleType: this.state.modules.find((ms) => ms.meetingModuleId == mm.meetingModuleId).moduleType,
      },
    });
  };
  selectLayout = (id, name) => {
    const { layouts } = this.state;
    const sl = layouts.find((l) => l.meetingLayoutId == id);
    if (sl && sl.templateId) {
      this.props.dispatch(templateActions.get(sl.templateId));
    }
    this.setState({ selectedLayout: { value: id, label: name } });
  };
  layoutTemplateOnChange = (templateId) => {
    const { layouts } = this.state;
    const { dispatch } = this.props;
    const selectedLayout = layouts.find((l) => l.meetingLayoutId == this.state.selectedLayout.value);
    if (selectedLayout) {
      const updatedLayout = deepClone(selectedLayout);
      updatedLayout.templateId = templateId;
      this.updateLayout(updatedLayout, this.onSave());
    }
    dispatch(templateActions.get(templateId));
  };
  parseModules = () => {
    const parsedModules = Array.from(this.state.modules);
    parsedModules.map((m) => {
      const pm = deepClone(m);
      if (typeof pm.settings == "string") {
        pm.settings = JSON.parse(pm.settings);
      }
      return pm;
    });
    return parsedModules;
  };
  copyModule = () => {
    const { eventId, selectedLayout, selectedModule, layouts, modules, changedModules, changedLayoutModules } = this.state;

    const copyOfSelectedModule = deepClone(selectedModule);
    const { posY, posX, width, height, zIndex, sortOrder, settings, displayName, moduleId, moduleType, meetingModuleId, meetingModuleLayoutId, meetingLayoutId } = copyOfSelectedModule;

    let layoutId = selectedLayout ? selectedLayout.value : -1000;
    let added = changedModules.filter((c) => c.added == true).length;
    let addedLm = changedLayoutModules.filter((c) => c.added == true).length;
    let mId = added * -1;
    let mLId = addedLm * -1;

    let meetingModule = {
      moduleType,
      eventId,
      meetingModuleId: mId,
      displayName: (displayName || "") + " (copy)",
      inserted: new Date().toISOString(),
      settings: settings,
    };
    let layoutModule = {
      posX,
      posY,
      width,
      height,
      zIndex,
      sortOrder: sortOrder,
      meetingLayoutId: layoutId,
      meetingModuleId: mId,
      meetingModuleLayoutId: mLId,
    };

    if (!modules.find((m) => m.meetingModuleId == meetingModule.meetingModuleId)) {
      modules.push(meetingModule);
      this.addOrUpdate({ ...meetingModule, added: true }, "changedModules", "meetingModuleId");
    }
    if (layoutId != -1000) {
      let index = layouts.indexOf(layouts.find((l) => l.meetingLayoutId == layoutModule.meetingLayoutId));
      if (index > -1) {
        this.addOrUpdate({ ...layouts[index], edited: true }, "changedLayouts", "meetingLayoutId");
        this.addOrUpdate(
          [
            { ...layoutModule, added: true },
            { ...layoutModule, meetingModuleId, meetingModuleLayoutId, deleted: true },
          ],
          "changedLayoutModules",
          "meetingModuleLayoutId"
        );
        layouts[index].meetingModules.push(layoutModule);
        layouts[index].meetingModules = layouts[index].meetingModules.filter((m) => m.meetingModuleLayoutId != copyOfSelectedModule.meetingModuleLayoutId);
      }
    }
    this.setState({
      layouts,
      isSavable: true,
      selectedModule: {
        ...copyOfSelectedModule,
        displayName: meetingModule.displayName,
        meetingLayoutId: layoutId,
        meetingModuleId: mId,
        meetingModuleLayoutId: mLId,
      },
    });
  };
  render() {
    const { templateIsSavable, templateLoaded, template, fonts } = this.props;

    const {
      modules,
      permissions,
      layouts,
      selectedLayout,
      isSavable,
      selectedModule,
      changedLayouts,
      changedLayoutModules,
      showLayoutGrid,
      preview,
      previewProps,
      eventName,
      eventId,
      eventCode,
      previewLoading,
      mainEventId,
      previewOpt,
      layoutsLoaded,
      gridLines,
      activeTemplateId,
      activeLayout,
      events,
    } = this.state;

    const layoutModules = this.getLayoutModules();
    const groupedTemplate = this.groupTemplate();
    const parsedModules = this.parseModules();

    let gridClassName = showLayoutGrid ? "hidden " : "show ";
    gridClassName += preview ? "no-size-reg center-view" : "grid-view";

    const connectionsProps = { hubConnection: this.hubConnection, ...this.state };
    return (
      <div style={{ background: "#1e2024" }}>
        <ConnectionStatus {...connectionsProps} />
        <div className="app-body" style={{ marginTop: "0px" }} />
        <FontBasline
          template={template}
          fonts={fonts}
          modules={this.state.modules.map((m) => {
            return m.settings;
          })}
        />
        {this.state.dialog ? <AlertDialog {...this.state.dialog} /> : null}
        <div
          className="aside-show da-sidebar"
          style={{
            position: "fixed",
            width: "320px",
            backgroundColor: "#1e2024",
            left: previewOpt || showLayoutGrid ? -320 : 0,
          }}
        >
          <div className="dark" ref={(r) => (this.asideEditorRef = r)}>
            <EditorSidebar
              modules={modules}
              permissions={permissions}
              onDeselect={() => this.setState({ selectedModule: null })}
              selectedModule={selectedModule}
              onSelect={this.onSelectModule}
              postionAndSizeOnChange={this.postionAndSizeOnChange}
              eventName={this.state.eventName}
              layoutName={selectedLayout ? selectedLayout.label : ""}
              onEdit={this.updateModule}
              events={events}
              copyModule={this.copyModule}
              eventName={eventName}
              eventId={eventId}
              mainEventId={mainEventId}
              selectLayout={(id, name) => this.selectLayout(id, name)}
              deleted={selectedModule ? changedLayoutModules.find((clm) => clm.meetingModuleLayoutId == selectedModule.meetingModuleLayoutId && clm.deleted == true) : false}
              layouts={layouts}
              updateLayout={this.updateLayout}
              selectedLayout={selectedLayout}
              deleteModule={this.deleteModule}
              deleteLayoutModule={this.deleteLayoutModule}
              addModule={this.addModule}
              activeModules={layoutModules}
            />
          </div>
        </div>
        {/* Flytta appbar till egen fil.. */}
        <AppBar position="static" style={{ width: showLayoutGrid || previewOpt ? "100%" : 320 }} className="header-bar dark-l2">
          <Toolbar style={{ padding: 0 }}>
            <div className="general-btn-bar">
              <button disabled={!isSavable && !templateIsSavable} onClick={this.beforeSave} className={"editor-full-btn" + (isSavable || templateIsSavable ? " savable-btn" : "")}>
                <Tooltip title={isSavable ? <SystemLabel name="Save" /> : <SystemLabel name="UpToDate" />}>
                  <span>
                    {this.state.saving ? (
                      <Spinner
                        style={{
                          width: "22px",
                          height: "22px",
                          borderWidth: "2px",
                        }}
                      />
                    ) : (
                      <SaveOutlinedIcon style={{ fontSize: 24 }} />
                    )}
                  </span>
                </Tooltip>
              </button>
              <div style={{ padding: 0 }} className={"editor-full-btn" + (previewOpt ? " preview-active" : "")}>
                <HeaderPopover tooltipText={"PreviewModes"} icon={<DesktopWindowsOutlinedIcon style={{ fontSize: 18 }} className="secondary-text" />}>
                  <div
                    className="pop-list"
                    style={{
                      minWidth: 300,
                      maxWidth: 310,
                      background: "rgb(70 71 83)",
                    }}
                  >
                    {[
                      { label: <SystemLabel name="NoPreview" />, value: null },
                      {
                        value: window.innerWidth * window.innerHeight,
                        label: `${window.innerWidth}x${window.innerHeight}`,
                      },
                      ...resolutions,
                    ].map((b, i) => {
                      return (
                        <React.Fragment key={i}>
                          <Row>
                            <Col>
                              <div
                                className={"list-option" + ((previewOpt && previewOpt.value == b.value) || (b.value == null && !previewOpt) ? " active-mode" : "")}
                                onClick={() => this.onPreview(b.label, b.value)}
                              >
                                {b.label}
                              </div>
                            </Col>
                          </Row>
                          <hr className="thin-hr-light" />
                        </React.Fragment>
                      );
                    })}
                  </div>
                </HeaderPopover>
              </div>

              <IconButton
                className="dark-btn"
                disabled={layouts.filter((l) => l.eventId == eventId).length == 0}
                style={{
                  marginLeft: -5,
                  color: "rgba(255, 255, 255, 0.54)",
                  "&:hover": {
                    color: "#fff",
                  },
                }}
                onClick={() => {
                  /*              if (layouts.length == 0) return; */
                  this.setState({
                    showLayoutGrid: !this.state.showLayoutGrid,
                  });
                }}
              >
                <Tooltip title={<SystemLabel name="Layouts" />}>
                  <ViewCompactOutlinedIcon />
                </Tooltip>
              </IconButton>
              <IconButton
                className="dark-btn"
                style={{
                  marginLeft: -5,
                  color: "rgba(255, 255, 255, 0.54)",
                  "&:hover": {
                    color: "#fff",
                  },
                }}
                onClick={() => this.setState({ gridLines: !gridLines })}
              >
                <Tooltip title={gridLines ? <SystemLabel name="HideGrideLines" /> : <SystemLabel name="ShowGridLines" />}>{gridLines ? <GridOffIcon /> : <GridOnIcon />}</Tooltip>
              </IconButton>
              <IconButton
                className="dark-btn"
                style={{
                  marginLeft: -5,
                  color: "rgba(255, 255, 255, 0.54)",
                  "&:hover": {
                    color: "#fff",
                  },
                }}
                onClick={() =>
                  
                  window.open(
                    `${window.location.origin}${!window.location.toString().includes("localhost") ? "/interaction" : ""}/digitalarena/${
                      this.state.selectedLayout && this.state.layouts.find((l) => l.meetingLayoutId == this.state.selectedLayout.value)?.mobile == true ? "mobile/" : ""
                    }${eventCode}?clientkey=${this.state.tickCode}${securityHelper.createGuid()}`,
                    "_blank"
                  )
                }
              >
                <Tooltip title={<SystemLabel name="GoToDigitalArena" />}>
                  <MeetingRoomOutlinedIcon />
                </Tooltip>
              </IconButton>
              <div style={{ marginTop: -10, width: 300 }}>{showLayoutGrid ? <EventSelector icon={false} eventId={eventId} eventName={eventName} events={events} /> : null}</div>
            </div>
          </Toolbar>
        </AppBar>
        <LayoutGrid
          show={layoutsLoaded && showLayoutGrid}
          layouts={layouts}
          events={events}
          eventId={eventId}
          selectedLayout={selectedLayout}
          selectLayout={(id, name) => this.selectLayout(id, name)}
          toggleGrid={() => this.setState({ showLayoutGrid: !showLayoutGrid })}
          onEdit={this.updateLayout}
          deleteLayout={this.deleteLayout}
          deletedLayouts={changedLayouts.filter((cl) => cl.deleted == true)}
          createLayout={this.createLayout}
          activeLayout={this.state.activeLayout}
        />
        <main
          style={{
            marginLeft: previewOpt || showLayoutGrid ? "0px" : "320px",
            height: "100vh",
          }}
          className="content-view"
        >
          <FontInjector {...this.props} />
          {previewLoading && !showLayoutGrid ? (
            <Spinner
              className="primary-text view-spinner"
              style={{
                width: "70px",
                height: "70px",
                borderWidth: "5px",
              }}
            />
          ) : null}

          <div
            id={selectedLayout && layouts.find((l) => l.meetingLayoutId == selectedLayout.value)?.mobile ? "GridViewMobile" : "GridView"}
            className={showLayoutGrid ? "hidden" : "show"}
            onDragEnter={(e) => {
              e.dataTransfer.dropEffect = "copy";
              e.preventDefault();
            }}
            onDragOver={(e) => {
              e.dataTransfer.dropEffect = "copy";
              e.preventDefault();
            }}
            className={gridClassName}
            ref={(ref) => (this.gridRef = ref)}
            style={
              groupedTemplate
                ? {
                    ...groupedTemplate.main,
                    ...previewStyle(previewProps),
                    opacity: previewLoading ? 0 : 1,
                  }
                : {
                    ...previewStyle(previewProps),
                  }
            }
          >
            {gridLines && this.gridRef ? <GridLines grid={this.gridRef} /> : null}

            {layoutModules.length > 0 && groupedTemplate
              ? layoutModules.map((m, i) => {
                  if (m) {
                    return (
                      <React.Fragment key={i}>
                        <ModuleWrapper
                          onChange={this.updateLayoutModule}
                          updateModule={this.updateModule}
                          name={m.moduleType}
                          module={m}
                          preview={this.state.previewOpt}
                          extra={{ eventId: this.state.eventId, hubConnection:this.hubConnection }}
                          gridLines={gridLines}
                          gridRef={this.gridRef}
                          eventName={eventName}
                          onSelect={() => {
                            if (this.state.previewOpt) return;
                            this.setState({
                              selectedModule: {
                                ...m,
                                moduleType: this.state.modules.find((ms) => ms.meetingModuleId == m.meetingModuleId).moduleType,
                              },
                            });
                          }}
                          settings={parsedModules.find((ms) => ms.meetingModuleId == m.meetingModuleId).settings}
                          deleted={changedLayoutModules.find((clm) => clm.meetingModuleLayoutId == m.meetingModuleLayoutId && clm.deleted == true)}
                          selected={selectedModule ? m.meetingModuleLayoutId == selectedModule.meetingModuleLayoutId : false}
                          position={{
                            zIndex: m.zIndex,
                            x: m.posX,
                            y: m.posY,
                          }}
                          size={{ height: m.height, width: m.width }}
                          layout={this.state.selectedLayout}
                          template={groupedTemplate}
                        />
                      </React.Fragment>
                    );
                  }
                })
              : null}
          </div>
        </main>
      </div>
    );
  }
}

const previewStyle = (props) => {
  if (!props) return {};
  const { scale, width, height, transform } = props;
  return {
    zoom: scale < 1 ? (scale > 0.8 ? 0.8 : scale) : 0.8,
    width: width,
    height: height,
    transform: `translate(-50%, -50%) ${scale < 0.5 ? `scale(${1 - transform + 1})` : ""}`,
  };
};

function mapStateToProps(state) {
  const { user } = state.authentication;
  return {
    user,
    alert: state.alert,
    page: state.page,
    fonts: state.cms.fonts,
    template: state.template.template,
    language: state.language,
    templateIsSavable: state.template.isSavable,
    templates: state.template ? state.template.templates : undefined,
    systemLabel: state.systemLabel,
    templateLoaded: state.template.loader,
  };
}
export default connect(mapStateToProps)(MeetingEditorLayout);
